import styled from 'styled-components';

export const StyledSpan = styled.span`
  color: #6c7778;
`;
